import { BaseCanvas } from "@visactor/vrender-core";

import { LynxContext2d } from "./context";

export class LynxCanvas extends BaseCanvas {
    constructor(params) {
        super(params);
    }
    init() {
        this._context = new LynxContext2d(this, this._dpr);
    }
    resize(width, height) {
        this._pixelWidth = width * this._dpr, this._pixelHeight = height * this._dpr, this._displayWidth = width, 
        this._displayHeight = height, this._nativeCanvas.width = this._pixelWidth, this._nativeCanvas.height = this._pixelHeight, 
        this._nativeCanvas.nativeCanvas && (this._nativeCanvas.nativeCanvas.width = this._pixelWidth, 
        this._nativeCanvas.nativeCanvas.height = this._pixelHeight);
        this._context.dpr = this._dpr;
    }
    release(...params) {}
}

LynxCanvas.env = "lynx";
//# sourceMappingURL=canvas.js.map
